import { Col, Row, Image } from "react-bootstrap";
import ga from "../../googleAnalytics";
import { useEffect } from "react";
import image from "../../media/images/Annnouncements/extensionsBG.jpg";

export const NewExtensionsService = ({ language }) => {
  const textToWrite =
    language === "eng" ? engText : language === "swe" ? sweText : finText;

  useEffect(() => {
    ga.trackPageView();
  });

  return (
    <Row>
      <Col>
        <Row>
          <Col>
            <h2 className="new-products-name">
              {language === "eng"
                ? engTitle
                : language === "swe"
                ? sweTitle
                : finTitle}
            </h2>
          </Col>
        </Row>
        <Row>
          <Col
            xs={{ span: 12, order: 1 }}
            md={{ span: 3, offset: 1, order: 1 }}
          >
            <Image
              alt="k18 all products"
              src={image}
              className="new-products-pic"
            ></Image>
          </Col>
          <Col
            xs={{ span: 12, order: 1 }}
            md={{ offset: 1, span: 5, order: 1 }}
          >
            {textToWrite.map((item, i) => {
              return (
                <div key={i}>
                  {item}
                  <br />
                </div>
              );
            })}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const finTitle = "Hiustenpidennykset";
const engTitle = "Hair extensions";
const sweTitle = "Hårförlängningar";

const finText = [
  "Uuden asiakkaan tulee aina varata aika veloituksettomaan pidennyskonsultaatioon, jolloin valitsemme yhdessä sinulle parhaiten sopivan hiustenpidennys tekniikan, hiustenpidennysten sävyn sekä laskemme tarkan hinnan. Tuuhennoksiin käytetään yleensä 1-2 pakettia hiusta ja pidennyksiin 2-5 pakettia hiusta.\nKonsultsatio ei velvoita sinua mihinkään. Mahdollinen varausmaksu maksetaan konsultaation yhteydessä.",
  "",
  "Teippipidennys on helppo, vaivaton ja nopea pidennysmenetelmä. Menetelmä sopii kaikille hiuslaaduille. Pidennykset pystyy käyttämään uudestaan ja huoltoväli on yleensä 5-8 viikkoa, jolloin pidennykset poistetaan, huolletaan uudella teipillä ja nostetaan hiusten tyveen uudestaan. Hiusten tuuhentamiseen tarvitset 1-3 pakettia hiusta ja koko pään pidennykseen 3-6 pakettia.",
  "",
  "Beaded Weft on moderni tapa kiinnittää hiustenpidennysnauha. Se on hellävarainen ja huomaamaton menetelmä, ja sopii kaikille hiuslaaduille. Hiuksiin kiinnitetään silikonilla päällystetyt beads-metallirenkaat joihin hiusnauha ommellaan kestävällä nylonlangalla.\nHiustentuhennokseen tarvitset 1-2 pakettia ja koko pään hiustenpidennykseen 3-4 pakettia.Suositeltu huoltoväli 8-12 viikkoa.",
  "",
  "Mago on hellävarainen hiustenpidennystekniikka, joka perustuu puuvillalangalla tehtyihin solmukiinnityksiin. Tekniikka sopii lähes kaikille, koska osioiden kiinnittämiseen tai poistoon ei tarvita mitään kemikaaleja. Lopputulos on kaunis ja luonnollinen. Magojen huoltoväli on 3-5kk, mago pidennyksiä ei voi käyttää uudelleen.",
  "",
  "Käytämme Pastell hair, BP hair ja Simply Natural hiuksia",
  "Pidennyksiä meillä tekee Emilia",
];

const sweText = [
  "Nya kunder ska alltid boka en kostnadsfri konsultation för hårförlängning. Under konsultationen väljer vi tillsammans den mest lämpliga metoden, rätt nyans på håret och räknar ut det exakta priset. För förtjockning används vanligtvis 1-2 paket hår och för hel förlängning 2-5 paket. Konsultationen förpliktar dig inte till något. En eventuell bokningsavgift betalas i samband med konsultationen.",
  "",
  "Tejpmetoden är en enkel, smidig och snabb metod som passar alla hårtyper. Förlängningarna kan återanvändas, och underhållet görs vanligtvis var 5-8 vecka. Då tas tejpen bort, förnyas och fästs tillbaka vid hårrötterna. För förtjockning behövs 1-3 paket hår och för en hel förlängning 3-6 paket.",

  "",
  "Beaded Weft är en modern metod för att fästa hårträns. Det är en skonsam och diskret metod som passar alla hårtyper. Silikonbelagda metallringar (beads) fästs i håret, och tränsen sys fast med stark nylontråd. För förtjockning behövs 1-2 paket och för hel förlängning 3-4 paket. Rekommenderat underhållsintervall: var 8-12 vecka.",
  "",
  "Mago är en skonsam hårförlängningsteknik som bygger på knutar gjorda med bomullstråd. Metoden passar nästan alla eftersom inga kemikalier används vid fästning eller borttagning. Resultatet är vackert och naturligt. Rekommenderat underhållsintervall: var 3-5 månad. Mago-förlängningar kan inte återanvändas.",
  "",
  "Vi använder Pastell Hair, BP Hair och Simply Natural hår.",
  "Hårförlängningar utförs av Emilia.",
];

const engText = [
  "New clients must always book a free hair extension consultation, during which we will together choose the most suitable extension method, match the hair color, and calculate the exact price. For volume extensions, 1-2 packs of hair are usually used, and for full extensions, 2-5 packs. The consultation does not obligate you to book the service. Any deposit required will be paid during the consultation.",
  "",
  "Tape Extensions are an easy, effortless, and quick method suitable for all hair types. The extensions can be reused, and the maintenance interval is usually every 5-8 weeks, when the tapes are removed, retaped, and lifted back to the roots. For volume, you’ll need 1-3 packs of hair, and for a full head, 3-6 packs.",
  "",
  "Beaded Weft is a modern way to attach a weft of hair extensions. It’s a gentle and discreet method suitable for all hair types. Small silicone-coated metal beads are attached to the hair, and the weft is sewn onto them using durable nylon thread. For volume, you’ll need 1-2 packs, and for a full head, 3-4 packs. Recommended maintenance interval: every 8-12 weeks.",
  "",
  "Mago Extensions are a gentle hair extension technique based on cotton-thread knots. The method suits almost everyone, as no chemicals are needed for attachment or removal. The result is beautiful and natural. The recommended maintenance interval is every 3-5 months. Mago extensions cannot be reused.",
  "",
  "We use Pastel hair, BP Hair and Simply Natural hair.",
  "Hair extensions are done by Emilia.",
];
